import { fmt } from '../lib/formatters';

export default function AccountStats({ balance, equity, totalPnl, totalMargin, freeMargin, positionCount }) {
  const equityClass = equity >= balance ? 'text-success' : 'text-error';
  const pnlClass = totalPnl >= 0 ? 'text-success' : 'text-error';

  return (
    <div className="stats stats-vertical lg:stats-horizontal shadow w-full bg-base-200">
      <div className="stat">
        <div className="stat-title">Balance</div>
        <div className="stat-value text-2xl text-primary">{fmt(balance)}</div>
        <div className="stat-desc">Account cash</div>
      </div>
      <div className="stat">
        <div className="stat-title">Equity</div>
        <div className={`stat-value text-2xl ${equityClass}`}>{fmt(equity)}</div>
        <div className="stat-desc">Balance + P&L</div>
      </div>
      <div className="stat">
        <div className="stat-title">Unrealized P&L</div>
        <div className={`stat-value text-2xl ${pnlClass}`}>{fmt(totalPnl)}</div>
        <div className="stat-desc">Open positions</div>
      </div>
      <div className="stat">
        <div className="stat-title">Margin</div>
        <div className="stat-value text-2xl">{fmt(totalMargin)}</div>
        <div className="stat-desc">Free: {fmt(freeMargin)}</div>
      </div>
      <div className="stat">
        <div className="stat-title">Positions</div>
        <div className="stat-value">{positionCount}</div>
        <div className="stat-desc">Active now</div>
      </div>
    </div>
  );
}
